import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, withDefaults } from "vue";
import { FileInputProps } from "@/types";
import { useVModel } from "@/hooks";
import { Icon } from "@/components/common/display";
import IconButton from "@/components/common/button/IconButton.vue";


/**
 * Displays a generic file selector.
 */
const __default__ = {
  name: "FileInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { default: undefined },
    errorMessage: { type: [String, Boolean], default: undefined },
    multiple: { type: Boolean },
    dataCy: { default: "input-files" }
  },
  emits: ["clear", "update:modelValue"],
  setup(__props: any) {

const props = __props;



const model = useVModel(props, "modelValue");

const showError = computed(
  () => !!props.errorMessage && props.errorMessage.length > 0
);
const label = computed(() => (props.multiple ? "Upload Files" : "Upload File"));

/**
 * Opens the SAFA WIKI docs.
 */
function handleOpenWiki() {
  window.open(
    "https://www.notion.so/nd-safa/Project-Creation-5ececa9fd233437ebb37ddf893d394df#6532e1d3f983453898a8bf6ffda007f4"
  );
}

return (_ctx: any,_cache: any) => {
  const _component_q_file = _resolveComponent("q-file")!

  return (_openBlock(), _createBlock(_component_q_file, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    clearable: "",
    filled: "",
    "use-chips": "",
    label: label.value,
    multiple: props.multiple,
    "error-message": props.errorMessage || '',
    error: showError.value,
    "data-cy": props.dataCy,
    hint: "File Types: .csv, .json",
    onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clear')))
  }, {
    prepend: _withCtx(() => [
      _createVNode(_unref(Icon), { variant: "file" })
    ]),
    append: _withCtx(() => [
      _createVNode(IconButton, {
        tooltip: "Read about the format of files",
        icon: "info",
        onClick: handleOpenWiki
      }),
      _renderSlot(_ctx.$slots, "append")
    ]),
    _: 3
  }, 8, ["modelValue", "label", "multiple", "error-message", "error", "data-cy"]))
}
}

})